import {
  Box,
  Container,
  ContentLayout,
  Link,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { leagueId } from '../../../leagueId';
import { RotatingLines, ThreeDots, BallTriangle } from  'react-loader-spinner'
import * as awsui from "@cloudscape-design/design-tokens";
import SeriesNav from "../../../components/series-navbar/series-nav";
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { CustomButton } from "../../../components/buttons";
import Rules from "./rules";
import Gallery from "./gallery";
import Register from './register';




export default function Series() {
  const { 
    theme, setTheme, 
    activeHref, setActiveHref,
    density, setDensity 
  } = useContext(GlobalContext);
  const { 
    activeSeries, setActiveSeries
  } = useContext(ContentContext);
  const [activeTabId, setActiveTabId] = useState("series");

  return (
    <>
    </>    
  );
}
